import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=2fca80e6&scoped=true&"
import script from "./journal.vue?vue&type=script&lang=js&"
export * from "./journal.vue?vue&type=script&lang=js&"
import style0 from "./journal.vue?vue&type=style&index=0&id=2fca80e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca80e6",
  null
  
)

export default component.exports